import HomeSmoke from './homeSmoke.svg';
import CottageNotSmoke from './home-not-smoke.svg';
import { alpha, Box, darken, IconButton, lighten, styled, Typography, } from '@mui/material';
import { useAnimationPermissions, useDesignPackage } from 'console/shared/hooks/helpers';
import { m } from 'framer-motion';
import { useMemo } from 'react';
import { BaseCard, BaseCardLabel } from 'console/shared/styles/mixins/base-card';
export const HeatingCircuitCard = styled(BaseCard, {
    shouldForwardProp: (prop) => prop !== 'mode_color' && prop !== 'error' && prop !== 'is_relay',
})(({ mode_color, error, is_relay, theme }) => {
    const allow_design_package = useDesignPackage();
    const animation_permissions = useAnimationPermissions();
    const anim_alarm = useMemo(() => allow_design_package && animation_permissions.circuit_alarm, [allow_design_package, animation_permissions.circuit_alarm]);
    return {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        border: `${mode_color
            ? `2.5px solid ${mode_color}`
            : `1px solid ${alpha(theme.palette.action.active, 0.12)}`}`,
        justifyContent: 'space-between',
        cursor: is_relay ? 'default' : 'pointer',
        WebkitTapHighlightColor: 'transparent',
        ...(anim_alarm &&
            error && {
            animation: '1.5s infinite alternate pulse',
            '@keyframes pulse': {
                '20%': {
                    backgroundColor: theme.palette.error.main,
                },
                '40%': {
                    backgroundColor: lighten(theme.palette.error.main, 0.3),
                },
                '60%': {
                    backgroundColor: theme.palette.error.main,
                },
                '80%': {
                    backgroundColor: lighten(theme.palette.error.main, 0.3),
                },
            },
        }),
    };
});
export const CircuitName = styled(BaseCardLabel)(({ fontSize }) => ({
    lineHeight: 1.5,
    fontSize: fontSize || '0.8em',
}));
export const OffCircuit = styled(Typography)({
    lineHeight: 1,
    fontSize: '0.6em',
});
export const CurrentState = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    columnGap: 4,
});
export const TargetState = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    columnGap: 4,
});
export const SetpointTemperature = styled(Typography)({
    fontSize: '0.6em',
});
export const TargetSensor = styled(Typography)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'center',
    fontSize: '0.6em',
});
export const ControlButton = styled(IconButton)(({ theme }) => ({
    minHeight: 40,
    minWidth: 40,
    backgroundColor: theme.palette.background.paper,
    ':hover': {
        backgroundColor: darken(theme.palette.background.paper, 0.1),
    },
}));
export const CircuitTransition = styled(m.div)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
});
export const defaultIconCard = HomeSmoke;
export const homeNotSmoke = CottageNotSmoke;
